<script setup lang="ts">
import { type ReserveType } from '@utils/itinerary';
const { service } = defineProps<{
    service: ReserveType | 'clock' | 'terminate' | 'edit' | 'draft' | 'rating';
}>();
const emit = defineEmits<{
    close: [args: boolean];
}>();

const title = computed(() => {
    switch (service) {
        case 'flight':
            return 'تغییر به حالت «پرواز دلخواه»';
        case 'bus':
            return 'تغییر به حالت «سرویس دلخواه»';
        case 'clock':
            return 'تغییر به حالت «زمان دلخواه»';
        case 'edit':
            return 'آیا مایل به ویرایش جزئیات هستید؟';
        case 'draft':
            return 'رزرو خودکار به عنوان پیش نویس ذخیره شد!';
        case 'rating':
            return 'از مِستربلیط راضی هستی؟';
        default:
            return 'آیا مایل به بازگشت هستید؟';
    }
});

const description = computed(() => {
    switch (service) {
        case 'terminate':
            return 'در صورت بازگشت، تنظیمات این صفحه از دست خواهند رفت!';
        case 'edit':
            return 'در صورت تایید، از این صفحه خارج و به صفحه نتایج جستجو باز می‌گردید!';
        case 'draft':
            return 'می‌توانید از طریق پنل کاربری بخش «مدیریت رزروهای خودکار» این درخواست را ویرایش یا فعال نمایید.';
        case 'rating':
            return 'لطفا با ثبت نظر خود در کافه بازار، انگیزه ما برای رشد و بهبود این اپلیکیشن رو بیشتر کنید...';
        default:
            return 'با تغییر به این حالت، تنظیمات قبلی از دست خواهند رفت!';
    }
});

const btnText = computed(() => {
    switch (service) {
        case 'terminate':
            return 'بله خارج می‌شوم';
        case 'edit':
            return 'بله خارج می‌شوم';
        case 'rating':
            return 'همین حالا نظر ثبت می‌کنم!';
        default:
            return 'متوجه شدم!';
    }
});

const imgIndicator = computed(() => {
    switch (service) {
        case 'edit':
            return 'terminate';
        case 'rating':
            return 'rating';
        default:
            return service;
    }
});

const submitText = computed(() => {
    switch (service) {
        case 'draft':
            return 'لیست رزروهای خودکار';
        case 'rating':
            return 'فعلا نه!';
        default:
            return 'انصراف';
    }
});
</script>
<template>
    <div class="modal-container">
        <img :src="`/img/auto-reserve/${imgIndicator}.png`" alt="warning" />
        <div class="conditions">
            <mr-typography size="large" weight="700">
                {{ title }}
            </mr-typography>
            <mr-typography align="center" color="var(--gray-800)">
                {{ description }}
            </mr-typography>
        </div>
        <div class="actions">
            <mr-button
                class="submit"
                variant="transparent"
                @click="emit('close', false)"
            >
                {{ submitText }}
            </mr-button>
            <mr-button full-width @click="emit('close', true)">
                {{ btnText }}
            </mr-button>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.modal-container {
    direction: rtl;
    display: flex;
    flex-direction: column;
    gap: 28.6px;
    align-items: center;
    width: 316px;
    padding: 24px 16px;
    .conditions {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
    }
    .actions {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 12px;
        .submit {
            flex-shrink: 0;
        }
    }
}
:global(.vfm__content) {
    height: fit-content;
    border-radius: 8px !important;
}
</style>
